// QuizzList.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import QuestionCard from "./QuestionCard";
import { AlertCircle, ArrowLeftCircle } from "lucide-react";
import { SERVER_ROUTE, DEFAULT_ROUTE } from "../../routes/api/api_routes";

const QuizzList = ({ quiz, onQuizFinished }) => {
  const navigate = useNavigate();
  const questionsLength = quiz?.questions?.length || 0;

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [progress, setProgress] = useState(Array(questionsLength).fill(null));

  const arraysEqual = (a, b) => {
    if (!Array.isArray(a)) a = [a];
    if (!Array.isArray(b)) b = [b];

    const sortedA = [...a].map(String).sort();
    const sortedB = [...b].map(String).sort();

    return JSON.stringify(sortedA) === JSON.stringify(sortedB);
  };

  const handleAnswer = async (selected, isCorrect) => {
    const updatedProgress = [...progress];
    updatedProgress[currentQuestion] = isCorrect ? "correct" : "wrong";
    setProgress(updatedProgress);

    // console.log("💡 Selected answer:", selected);

    // Stocker l’ID de l’option choisie dans la question
    quiz.questions[currentQuestion].user_choice_id = selected;
    // console.log("💡 Question updated:", quiz.questions[currentQuestion]);

    // 🔹 Envoyer la réponse au backend
    try {
      const isLastQuestion = currentQuestion === questionsLength - 1;
      await fetch(
        `${DEFAULT_ROUTE}send_response/${quiz.questions[currentQuestion].id}/${quiz.id}/${selected.id}/${isLastQuestion}/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${localStorage.getItem("access")}`,
          },
        }
      );
      // console.log("✅ Réponse envoyée au backend", {
      //   question: currentQuestion + 1,
      //   completed: isLastQuestion,
      // });
    } catch (err) {
      console.error("❌ Erreur lors de l'envoi de la réponse :", err);
    }

    setTimeout(() => {
      if (currentQuestion < questionsLength - 1) {
        setCurrentQuestion((prev) => prev + 1);
      } else {
        const finalScore = updatedProgress.filter(
          (val) => val === "correct"
        ).length;
        if (onQuizFinished) {
          onQuizFinished(finalScore, questionsLength);
        }
      }
    }, 1500);
  };

  if (questionsLength === 0) {
    return (
      <div className="flex flex-col items-center justify-center text-red-500 py-10 relative">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 left-4 sm:top-6 sm:left-6 bg-teal-600 text-white hover:bg-teal-800 transition rounded-full z-10"
        >
          <ArrowLeftCircle size={32} />
        </button>
        <AlertCircle className="w-16 h-16 animate-bounce-slow mb-4" />
        <p className="text-lg font-semibold text-center">
          Aucune question trouvée pour ce quiz.
        </p>
      </div>
    );
  }

  const current = quiz.questions[currentQuestion];

  return (
    <div className="px-4 sm:p-6">
      <QuestionCard
        questionData={current}
        currentIndex={currentQuestion}
        handleAnswer={handleAnswer}
        progress={progress}
      />
    </div>
  );
};

export default QuizzList;
